const MS_TO_KMH = 3.6;

export interface WeatherUnits {
  temperature: string;
  formatWindSpeed: (windSpeed: number) => string;
}

// Note: mirrors the BE (WeatherService): US gets imperial values, any other country gets metric (wind in m/s)
export const getWeatherUnits = (country?: string): WeatherUnits => {
  if (!country || country === 'US') {
    return {
      temperature: '°F',
      formatWindSpeed: (windSpeed) => `${windSpeed} mph`,
    };
  }

  return {
    temperature: '°C',
    formatWindSpeed: (windSpeed) => `${Math.round(windSpeed * MS_TO_KMH)} km/h`,
  };
};
